import { combineReducers } from 'redux';
import menu from './menu';
import loginReducer from '@/views/login/store/reducers/user';
import companyReducer from '@/views/login/store/reducers/company';
import employeeReducer from '@/views/HR/employee-master/employee-details/profile-detail/store/reducers/employee';
import divisionReducer from '@/views/login/store/reducers/division';
import forgotPasswordReducer from '@/views/login/store/reducers/forgotPassword';
import payslipReducer from '@/views/HR/employee-master/employee-details/finance-detail/payslip-details/store/reducers/payslip';
import appReducer from './app';
import tabReducer from '@/views/HR/employee-master/add-employee/reducers/tab';
import newEmployeeReducer from '@/views/HR/employee-master/add-employee/reducers/emp';
import newEmpDtlReducer from '@/views/HR/employee-master/add-employee/reducers/empDtl';
import newEmpFinanceDtlReducer from '@/views/HR/employee-master/add-employee/reducers/financeDtl';
import editEmpDtlReducer from '@/views/HR/employee-master/add-employee/reducers/editEmpDtl';
import editProductDtlReducer from '@/views/products/Excel Import/reducers/editProductDtl';
import editBarcodeDtlReducer from '@/views/products/Excel Import/reducers/editBarcodeDtl';
import editPrateDtlReducer from '@/views/products/Excel Import/reducers/editPrateDtl';
import uiParamDtlReducer from '@/views/configurations/uiConfig/store/reducers/param';
import uiReportIdReducer from '@/views/configurations/uiConfig/store/reducers/reportId';
import createProductDtlReducer from '@/views/products/Excel Import/reducers/createProductDtl';
import snackbarReducer from './snackbarReducer';
import userConfigReducer from './userConfig';

const reducers = combineReducers({
  menu,
  loginReducer,
  employeeReducer,
  companyReducer,
  divisionReducer,
  payslipReducer,
  appReducer,
  forgotPasswordReducer,
  tabReducer,
  newEmployeeReducer,
  newEmpDtlReducer,
  newEmpFinanceDtlReducer,
  editEmpDtlReducer,
  uiParamDtlReducer,
  uiReportIdReducer,
  snackbarState: snackbarReducer,
  editProductDtlReducer,
  editBarcodeDtlReducer,
  editPrateDtlReducer,
  createProductDtlReducer,
  userConfig: userConfigReducer,
});

export default reducers;
